<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loading="loading" :disabled="loading">
        <v-card-title class="subtitle-1">
          {{field == "suspensao_perda_rouboComponent" ? "Suspensão Perda ou Roubo" : "Suspensão de Linha Voluntária"}}
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-btn color="primary" class="mr-2" @click="clickAddNewLine()">Selecionar linha</v-btn>
            <v-btn v-if="groupUser == 1 || groupUser == 2" color="success" @click="showModalImport = true"><v-icon left>mdi-database-import</v-icon>Importar arquivo</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      md="6"
      sm="12"
      v-for="(lineSelected, index) in lineSelect"
      :key="index"
    >
      <v-card outlined class="mx-auto">
        <v-card-title class="primary white--text">
          <div class="headerClass">
            {{lineSelected.line.ddi ? lineSelected.line.ddi+' ('+lineSelected.line.ddd+') '+lineSelected.line.nr_linha : 'Selecione uma linha' }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeLine(index)" class="mx-3 mt-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <LineComponent
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                :selectedLine="lineSelected.line"
                @save="
                  lineSelected.line = $event;
                  updateSelectedLine($event, lineSelected, index)
                "
              ></LineComponent>

              <v-select
                v-if="groupUser == 1 || groupUser == 2"
                :items="field.options_situation"
                item-text="label"
                item-value="option"
                label="Informar Situação"
                v-model="lineSelected.situation"
                return-object
                dense
                outlined
                @change="updateValues"
              ></v-select>
              <v-autocomplete
                v-if="(groupUser == 1 || groupUser == 2) && lineSelected.situation && lineSelected.situation.value === 3"
                dense
                outlined
                required
                label="Tipo Baixa"
                v-model="lineSelected.tipo_baixa"
                :items="field.tipo_baixa_aparelho"
                item-text="name"
                item-value="value"
                return-object
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                @change="updateValues"
              >
              </v-autocomplete>

              <DatePickerComponent
                v-if="field.automation_id === 24"
                v-model="lineSelected.date_prev_reactivation"
                label="Data de Previsão de Reativação"
                placeholder="Selecione a data"
                :required="true"
                :clearable="true"
                :disabled="loading"
                :maxDaysFromToday="120"
                :minDaysFromToday="0"
                :error-messages="getDateErrorMessages(lineSelected)"
                @change="onDateChange(lineSelected)"
              ></DatePickerComponent>
            </v-col>
            <ListPackage
                v-if="loadingLinePackages[index]"
                :loadingPackage="loadingLinePackages[index].value"
                :lineSelected="lineSelected"
            >
            </ListPackage>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <ImportDataSolicitationDialogComponent
      v-if="showModalImport"
      :title="'Linhas Identificadas'"
      :automation=8
      @closeDialog="showModalImport = false"
      @importValues="importValues($event)"
    ></ImportDataSolicitationDialogComponent>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import ListPackage from "@/components/package/ListPackage";
import LineComponent from "@/components/forms/LineComponent.vue";
import ImportDataSolicitationDialogComponent from "@/components/dialog/ImportDataSolicitationDialogComponent.vue";
import DatePickerComponent from "@/components/forms/DatePickerComponent.vue";
import isEmpty from "lodash/isEmpty";
export default {
  components: { DatePickerComponent, ImportDataSolicitationDialogComponent, LineComponent, ListPackage},
  props: {
    field: {},
    index: {},
    groupUser: null,
    uniqueKeyStorage: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lineSelect: [],
      loading: true,
      show: false,
      showModalImport: false,
      showDateLimitRule: false,
      showRequiredDateRule: false,
      maxLength: 50,
      lineRules: [v => !!v || "Linha é obrigatório"],
      loadingLinePackages: []
    };
  },
  async mounted() {
    const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
    if (!isEmpty(dataLocalStorage) && this.page === 'wizard') {
      this.resultStorage = dataLocalStorage;
      this.lineSelect = Object.assign([], this.resultStorage);
      this.lineSelect.forEach(value => {
        this.loadingLinePackages.push({ value: false });
      });
    } else {
      await this.clickAddNewLine();
    }
    this.loading = false;
  },
  computed: {
    ...mapState("packages", ["lines"]),
    ...mapGetters({
      linePackages: "packages/getLinePackages"
    })
  },
  methods: {
    ...mapActions("packages", ["loadLinePackages"]),
    ...mapActions("solicitation", ["loadDataLocalStorage"]),
    ...mapMutations({ setModel: "forms/setModelVoluntaryLineSuspension" }),

    importValues(data) {
      const existingIds = new Set(this.lineSelect.map(item => item.line.id_linha));
      const filtered = data.filter(
        item => !existingIds.has(item.id_linha)
      );

      this.lineSelect.push(...filtered);
      this.updateValues(this.lineSelect);
      this.lineSelect.forEach(value => {
        this.loadingLinePackages.push({ value: false });
      });
      this.showModalImport = false;
    },
    onDateChange(lineSelected) {
      this.updateValues();
    },
    getDateErrorMessages(lineSelected) {
      const messages = [];
      if (!lineSelected.date_prev_reactivation && this.showRequiredDateRule) {
        messages.push('A data é obrigatória');
      }
      if (lineSelected.date_prev_reactivation) {
        const selectedDate = new Date(lineSelected.date_prev_reactivation);
        const maxDate = new Date(this.maxDate);
        if (selectedDate > maxDate && this.showDateLimitRule) {
          messages.push('A data não pode ser superior a 120 dias');
        }
      }
      return messages;
    },
    validateReactivationDate() {
      if (this.reactivationDate != "" && this.reactivationDate != null) {
        this.showRequiredDateRule = false;
        if (this.reactivationDate > this.validationDate) {
          this.showDateLimitRule = true;
        } else {
          this.showDateLimitRule = false;
        }
      } else {
        this.showDateLimitRule = false;
        this.showRequiredDateRule = true;
      }
      this.updateFields();
    },
    async clickAddNewLine() {
      const newLine = {
        packages: [],
        line: {},
        date_prev_reactivation: null
      };

      if (this.lineSelect.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", 'O número máximo de cards dessa solicitação é '+this.maxLength+'.', "info");
      } else {
        this.loadingLinePackages.push({
          value: false
        });
        this.lineSelect = [newLine, ...this.lineSelect];
        this.updateValues();
      }
    },
    async updateSelectedLine(line, lineSelected, index) {
      this.show = this.show ? false : lineSelected;
      this.loadingLinePackages[index].value = true;
      if (line.id_linha) {
        lineSelected.packages = [];
        await this.loadLinePackages({
          id_linha: line.id_linha,
          type: "old"
        }).catch(error => {
          this.$swal("Oops...", error.message, "error");
        });
        lineSelected.packages = this.linePackages.data;
      }
      this.updateValues();
      this.show = false;
      this.loadingLinePackages[index].value = false;
    },
    updateValues() {
      const payload = {
        step: this.index,
        selected: {
          model: {lines: this.lineSelect},
          revision: {lines: this.lineSelect}
        }
      }
      this.setModel(payload);
      if (this.page === 'wizard') {
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(this.lineSelect));
      }
    },
    closeLine(index) {
      if (index > -1) {
        this.lineSelect.splice(index, 1);
        this.loadingLinePackages.splice(index, 1);
        this.updateValues();
      }
    },
    customFilter(item, queryText) {
      queryText = queryText.replace(/[\s()\-/]/g, '');
      const regExp = new RegExp(queryText, 'i')
      const phoneNumber = item.ddi + item.ddd + item.nr_linha;
      return (
        regExp.test(phoneNumber) || regExp.test(item.nome_completo.replace(/\s/g, ''))
      );
    }
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
